import { formatDate } from '@/portainer/filters/filters';

import { AlertRulesResponse, AlertRuleRow } from '../../types';

export function transformToAlertRuleRow(alertRule: AlertRuleRow): AlertRuleRow {
  return {
    ...alertRule,
    createdAt: formatDate(new Date(alertRule.createdAt)),
    updatedAt: alertRule.updatedAt
      ? formatDate(new Date(alertRule.updatedAt))
      : undefined,
    isEditable: alertRule.isEditable ?? false,
  };
}

export function transformArrayToAlertRuleRow(
  alertRules: AlertRulesResponse
): Array<AlertRuleRow> {
  return alertRules.map((alertRule) => transformToAlertRuleRow(alertRule));
}
